import { render, staticRenderFns } from "./cusList.vue?vue&type=template&id=11c0447a&scoped=true&"
import script from "./cusList.vue?vue&type=script&lang=js&"
export * from "./cusList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c0447a",
  null
  
)

export default component.exports